import { GenericService } from './generic-service'

class MidiaService extends GenericService {
  constructor () {
    super('/midias')
  }
}

export default new MidiaService()
